/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductBatteryHubList } from '../models/PaginatedProductBatteryHubList';
import type { PatchedProductBatteryHub } from '../models/PatchedProductBatteryHub';
import type { ProductBatteryHub } from '../models/ProductBatteryHub';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsBatteryHubsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductBatteryHubList
     * @throws ApiError
     */
    public productsBatteryHubsList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductBatteryHubList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-battery-hubs/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductBatteryHub
     * @throws ApiError
     */
    public productsBatteryHubsCreate({
        requestBody,
    }: {
        requestBody: ProductBatteryHub,
    }): CancelablePromise<ProductBatteryHub> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-battery-hubs/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductBatteryHub
     * @throws ApiError
     */
    public productsBatteryHubsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product battery hub.
         */
        id: number,
    }): CancelablePromise<ProductBatteryHub> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-battery-hubs/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductBatteryHub
     * @throws ApiError
     */
    public productsBatteryHubsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product battery hub.
         */
        id: number,
        requestBody: ProductBatteryHub,
    }): CancelablePromise<ProductBatteryHub> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-battery-hubs/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductBatteryHub
     * @throws ApiError
     */
    public productsBatteryHubsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product battery hub.
         */
        id: number,
        requestBody?: PatchedProductBatteryHub,
    }): CancelablePromise<ProductBatteryHub> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-battery-hubs/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsBatteryHubsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product battery hub.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-battery-hubs/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
